import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-delete-promotion',
    templateUrl: './delete-promotion.component.html',
    styleUrls: ['./delete-promotion.component.scss'],
    standalone: false
})
export class DeletePromotionComponent implements OnInit {
  promotionId: any;
  promotionCode: any;

  constructor(public dialog: MatDialog,
              public dialogRef: MatDialogRef<DeletePromotionComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private dataService: DataService) {
                this.promotionId = this.data.id;
                this.promotionCode = this.data.code;
              }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  deletePromotion() {
    this.dataService.delete('promotionCode/DeletePromotionCode/' + this.promotionId).then((data) => {
      if (data.statusCode === 200) {
        this.dialogRef.close('delete');
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Promotion deleted successfully',
            buttonText: 'Ok'
          }
        });
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

}
